<div [formGroup]="form" class="mb-3">
    <div class="form-label">
        {{ 'common_COUNTRY_ZIP' | translate: 'online' : 'common' }}
    </div>
    <div class="grid">
        <input
            [class.is-invalid]="
                form.controls['country'].invalid && form.controls['country'].touched
            "
            class="form-control"
            formControlName="country"
            id="country"
            maxlength="2"
            appUppercase
            type="text" />

        <input
            [class.is-invalid]="
                form.controls['postalCode'].invalid && form.controls['postalCode'].touched
            "
            class="form-control"
            formControlName="postalCode"
            maxlength="10"
            type="text"
            (blur)="onTouch?.()" />

        @if (editableCity) {
            <input
                [class.is-invalid]="form.controls['city'].invalid && form.controls['city'].touched"
                class="form-control"
                formControlName="city"
                maxlength="50"
                type="text" />
        }
    </div>
</div>
